import React, { useEffect, useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import Select from 'react-select';
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';
import { ModalContext } from 'App';
import moment from 'moment';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import Alert from 'react-s-alert';
import { customStyle } from 'helper';
import useFormValidator from 'useFormValidator';
import AddressRemove from 'modules/common/address/AddressRemove';
import withForm from 'modules/common/hoc/withForm';
import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import DragAndDrop from 'modules/common/components/DragAndDrop';
import Modal from 'modules/common/components/Modal';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import CmsContext from 'context/CmsContext';
import * as actions from '../../../action';
import * as c from '../../../constant';
import FloorArea from '../../components/FloorArea';
import StructuralMaterialsList from '../../components/structural-materials/StructuralMaterialsList';
import AdditionalItemsList from '../../components/additional-items/AdditionalItemsList';

const quarterList = [
  { label: '1ST QUARTER', value: '1' },
  { label: '2ND QUARTER', value: '2' },
  { label: '3RD QUARTER', value: '3' },
  { label: '4TH QUARTER', value: '4' },
];

const years = _.range(1970, +moment().format('YYYY') + 1).sort((a, b) => b - a);

function NewDeclarationModal({
  getOwnerList,
  ownerList,
  createApplication,
  getBuildingKindsList,
  buildingKindsList,
  getStructuralTypesList,
  structuralTypesList,
  structuralTypesIsLoading,
  createUploader,
  getApplicationsList,
  history,
  getSingleBuildingOwner,
  findTdn,
  transactionCode,
  createRichTextEditor,
  showStructuralType,
  formData,
  setFormData,
  modalType,
  updateList,
  getBarangayList,
  barangayList,
  getDistrictList,
  districtList,
  convertToRaw,
  draftToHtml,
  updateApplication,
  htmlToDraft,
  getAppointedPersons,
  appointedPersonsList,
  searchPin,
  showData,
  applicationId,
  ordinanceRevisionId,
  isLoading
}) {
  const setModal = useContext(ModalContext);
  const cmsContext = useContext(CmsContext);
  const CMS_COMPONENTS = cmsContext.findByType('COMPONENTS');

  const [showPaginateButton, setShowPaginateButton] = useState(false);

  const RULES = {
    tab0: {
      rules: {
        rptax_owner_id: 'required',
      },
    },
    tab2: {
      rules: {
        property_district_id: 'required',
        property_barangay_id: 'required',
        property_street: 'required',
        td_owner: 'required',
      },
    },
    tab4: {
      rules: {
        floor_plan_photo_url: 'required',
      },
    },
    tab9: {
      rules: {
        effectivity_of_assessment_reassessment_yr: 'required',
        effectivity_of_assessment_reassessment_qtr: 'required',
        appraised_assessed_by_id: 'required',
        appraised_assessed_at: 'required',
        recommending_by_id: 'required',
        recommending_at: 'required',
        approved_by_id: 'required',
        approved_at: 'required',
        registered: 'required',
      },
    },
  };

  const [tab, setTab] = useState(0);

  let commonValidation = {
    rptax_building_kind_id: 'required',
    rptax_building_structural_type_id: 'required',
    building_permit_no: 'required',
    date_issued: 'required',
    certificate_completion_issued_on: 'required',
    certificate_occupancy_issued_on: 'required',
    date_constructed_completed: 'required',
    date_occupied: 'required',
  };

  let commonValidationTab2 = {};

  const tab0Validator = useFormValidator(
    formData,
    RULES.tab0.rules,
    RULES.tab0.message
  );

  const tab2Validator = useFormValidator(formData, commonValidationTab2);

  const tab3Validator = useFormValidator(formData, commonValidation);

  const tab4Validator = useFormValidator(
    formData,
    RULES.tab4.rules,
    RULES.tab4.message
  );

  const tab9Validator = useFormValidator(
    formData,
    RULES.tab9.rules,
    RULES.tab9.message
  );

  const tab0Field = _.pick(formData, [
    'rptax_owner_id',
    'owner_telephone_no',
    'owner_tin',
    'owner_province_city',
    'owner_municipality',
    'owner_brgy_district',
    'owner_no_street',
  ]);

  const tab2Field = _.pick(formData, [
    'rptax_land_application_id',
    'rptax_building_application_id',
  ]);

  const tab3Field = _.pick(formData, [
    'rptax_building_kind_id',
    'condominium_certificate_title',
    'condominium_certificate_title_date',
    'rptax_building_structural_type_id',
    'building_age',
    'building_permit_no',
    'date_issued',
    'certificate_completion_issued_on',
    'certificate_occupancy_issued_on',
    'date_constructed_completed',
    'date_occupied',
  ]);

  const tab4Field = _.pick(formData, ['floor_plan_photo_url']);

  const tab9Field = _.pick(formData, [
    'effectivity_of_assessment_reassessment_yr',
    'effectivity_of_assessment_reassessment_qtr',
    'appraised_assessed_by_id',
    'appraised_assessed_at',
    'recommending_by_id',
    'recommending_at',
    'approved_by_id',
    'approved_at',
    'registered',
  ]);

  useEffect(() => {
    if (_.isEmpty(applicationId)) return;
    showData(applicationId);
  }, []);
  useEffect(() => {
    if (_.isEmpty(applicationId)) return;
    showData(applicationId);
  }, [applicationId]);

  useEffect(() => {
    if (
      parseInt(formData.rptax_building_kind_id, 10) === 1 ||
      parseInt(formData.rptax_building_kind_id, 10) === 2
    ) {
      commonValidation = {
        ...commonValidation,
        condominium_certificate_title: 'required',
        condominium_certificate_title_date: 'required',
      };
    }
    tab3Validator.onSetObjectRules(commonValidation);
  }, [formData]);

  useEffect(() => {
    tab2Validator.validate();
  }, [Object.values(tab2Field).join(',')]);

  useEffect(() => {
    tab3Validator.validate();
  }, [Object.values(tab3Field).join(',')]);

  useEffect(() => {
    tab4Validator.validate();
  }, [Object.values(tab4Field).join(',')]);

  useEffect(() => {
    tab0Validator.validate();
  }, [Object.values(tab0Field).join(',')]);

  useEffect(() => {
    tab9Validator.validate();
  }, [Object.values(tab9Field).join(',')]);

  const validateForm = () => {
    if (tab === 0) {
      if (!tab0Validator.response.is_passed) {
        return false;
      }

      return setTab(+tab + 1);
    }

    if (tab === 1) {
      return setTab(+tab + 1);
    }

    if (tab === 2) {
      if (!tab2Validator.response.is_passed) {
        return false;
      }
      return setTab(+tab + 1);
    }

    if (tab === 3) {
      if (!tab3Validator.response.is_passed) {
        return false;
      }
      return setTab(+tab + 1);
    }

    if (tab === 4) {
      if (!tab4Validator.response.is_passed) {
        return false;
      }
      return setTab(+tab + 1);
    }

    if (tab === 5 || tab === 6 || tab === 7 || tab === 8) {
      return setTab(+tab + 1);
    }

    if (tab === 9) {
      if (!tab9Validator.response.is_passed) {
        return false;
      }
    }

    return true;
  };

  useEffect(() => {
    getAppointedPersons();
  }, []);

  useEffect(() => {
    getOwnerList();
  }, []);

  useEffect(() => {
    getBuildingKindsList({
      status: 1,
    });
  }, []);

  const formatFloorArea = (data) => {
    const format = data.map((item) => ({
      id: _.get(item, 'id'),
      floor: _.get(item, 'attributes.floor'),
      area: _.get(item, 'attributes.area'),
    }));
    return format;
  };

  const formatStructuralMaterials = (data) => {
    const format = data.map((item) => ({
      id: _.get(item, 'id'),
      rptax_building_material_id: _.get(
        item,
        'attributes.rptax_building_material_id'
      ),
      rptax_building_material_name: _.get(
        item,
        'attributes.rptax_building_material_name'
      ),
      rptax_building_material_type_id: _.get(
        item,
        'attributes.rptax_building_material_type_id'
      ),
      rptax_building_material_type_name: _.get(
        item,
        'attributes.rptax_building_material_type_name'
      ),
      material_name: _.get(item, 'attributes.rptax_building_material_name'),
      floor: _.get(item, 'attributes.floor'),
    }));
    return format;
  };

  const formatAddionalItems = (data) => {
    const format = data.map((item) => ({
      id: _.get(item, 'id'),
      area: _.get(item, 'attributes.area'),
      is_add_area: _.get(item, 'attributes.is_add_area'),
      rptax_building_application_id: _.get(
        item,
        'attributes.rptax_building_application_id'
      ),
      rate: _.get(item, 'attributes.rate'),
      rptax_building_component_id: _.get(
        item,
        'attributes.rptax_building_component_id'
      ),
      floor: _.get(item, 'attributes.floor'),
      rptax_actual_use_id: _.get(item, 'attributes.rptax_actual_use_id'),
    }));
    return format;
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();

    if (validateForm() !== true) {
      return false;
    }

    const newList = (formData.structural_materials || []).reduce(
      (acc, data) => {
        const floor = (data.floor || []).map((x) => x);

        const existing = acc.find(
          (item) =>
            item.rptax_building_material_type_id ===
            data.rptax_building_material_type_id
        );

        if (existing) {
          existing.materials.push({
            rptax_building_material_id: data.rptax_building_material_id,
            floor,
          });
        } else {
          acc.push({
            rptax_building_material_type_id:
              data.rptax_building_material_type_id,
            materials: [
              {
                rptax_building_material_id: data.rptax_building_material_id,
                floor,
              },
            ],
          });
        }
        return acc;
      },
      []
    );

    const oldList = (formData.structural_materials || []).reduce(
      (acc, data) => {
        const src = data?.attributes || data;

        const existing = acc.find(
          (item) =>
            item.rptax_building_material_type_id ===
            src.rptax_building_material_type_id
        );

        if (existing) {
          existing.materials.push({
            rptax_building_material_id: src.rptax_building_material_id,
            floor: _.get(src, 'floor').length === 0 ? [] : src.floor,
          });
        } else {
          acc.push({
            rptax_building_material_type_id:
              src.rptax_building_material_type_id,
            materials: [
              {
                rptax_building_material_id: src.rptax_building_material_id,
                floor: _.get(src, 'floor').length === 0 ? [] : src.floor,
              },
            ],
          });
        }

        return acc;
      },
      []
    );

    let condoInfo = {};

    if (
      parseInt(formData.rptax_building_kind_id, 10) === 1 ||
      parseInt(formData.rptax_building_kind_id, 10) === 2
    ) {
      condoInfo = {
        condominium_certificate_title_date: `${moment(
          _.get(formData, 'condominium_certificate_title_date')
        ).format('YYYY-MM-DD')}`,
      };
    } else {
      condoInfo = {
        condominium_certificate_title_date: '',
      };
    }

    const args = {
      ...formData,
      ...condoInfo,
      rptax_land_application_id: formData.land_application_id,
      rptax_building_application_id: formData.building_application_id,
      property_province_id: 65,
      floor_storey_areas: formData.floor_storey_areas,
      structural_materials: modalType === 'NEW' ? newList : oldList,
      rptax_transaction_code_id: transactionCode,
      date_issued: `${moment(_.get(formData, 'date_issued')).format(
        'YYYY-MM-DD'
      )}`,

      date_constructed_completed: `${moment(
        _.get(formData, 'date_constructed_completed')
      ).format('YYYY-MM-DD')}`,
      date_occupied: `${moment(_.get(formData, 'date_occupied')).format(
        'YYYY-MM-DD'
      )}`,

      appraised_assessed_at: `${moment(
        _.get(formData, 'appraised_assessed_at')
      ).format('YYYY-MM-DD HH:mm:00')}`,
      recommending_at: `${moment(_.get(formData, 'recommending_at')).format(
        'YYYY-MM-DD HH:mm:00'
      )}`,
      approved_at: `${moment(_.get(formData, 'approved_at')).format(
        'YYYY-MM-DD HH:mm:00'
      )}`,
      registered: `${moment(_.get(formData, 'registered')).format(
        'YYYY-MM-DD HH:mm:00'
      )}`,
      memoranda: draftToHtml(
        convertToRaw(formData.memoranda.getCurrentContent())
      ),
      certificate_completion_issued_on: `${moment(
        _.get(formData, 'certificate_completion_issued_on')
      ).format('YYYY-MM-DD')}`,
      certificate_occupancy_issued_on: `${moment(
        _.get(formData, 'certificate_occupancy_issued_on')
      ).format('YYYY-MM-DD')}`,
    };

    if (tab === 9 && modalType === 'NEW') {
      createApplication(args, (data) => {
        setModal({ isOpen: false });
        getApplicationsList();
        history.push(`/rpt/building/applications/${_.get(data, 'data.id')}`);
        showData(_.get(data, 'data.id'));
      });
    } else if (tab === 9 && modalType === 'EDIT') {
      updateApplication(formData.id, args, (data) => {
        setModal({ isOpen: false });
        getApplicationsList();
        history.push(`/rpt/building/applications/${_.get(data, 'data.id')}`);
        showData(_.get(data, 'data.id'));
      });
    }
    return false;
  };

  const closeModal = (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure you want to cancel adding this record? Changes won`t be saved.',
      () => {
        setModal({ isOpen: false });
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const onChange = (e) => {
    return setFormData({
      ...formData,
      [e.target.name]:
        e.target.type === 'checkbox' ? e.target.checked : e.target.value,
    });
  };

  const handleOnChangeSelect = (key) => (e) => {
    if (key === 'property_district_id') {
      getBarangayList({
        rptax_district_id: e.value,
      });
      setFormData({
        ...formData,
        [key]: e.value,
      });
    }

    if (key === 'rptax_building_kind_id') {
      setFormData({
        ...formData,
        [key]: e.value,
        rptax_building_structural_type_id: '',
        condominium_certificate_title: '',
        condominium_certificate_title_date: '',
      });
      getStructuralTypesList(e.value, {
        status: 1,
        ordinance_revision_id: ordinanceRevisionId,
      });
    }

    if (key === 'rptax_building_structural_type_id') {
      showStructuralType(
        formData.rptax_building_kind_id,
        e.value,
        ({ data }) => {
          setFormData({
            ...formData,
            [key]: e.value,
            buv: _.get(data, 'attributes.unit_construction_cost'),
          });
        }
      );
    }

    if (key === 'rptax_owner_id') {
      getSingleBuildingOwner(e.value, ({ data }) => {
        setFormData({
          ...formData,
          [key]: e.value,
          owner_telephone_no: data.attributes.telephone_no,
          owner_tin: data.attributes.tin,
          owner_region_code: data.attributes.region_name,
          owner_province_code: data.attributes.province_name,
          owner_municipality_code: data.attributes.municipality_name,
          owner_barangay_code: data.attributes.barangay_name,
          address_line: data.attributes.address_line,
        });
      });
      setFormData({
        ...formData,
        [key]: e.value,
      });
    }

    if (key === 'administrator_beneficial_user_id') {
      getSingleBuildingOwner(e.value, ({ data }) => {
        setFormData({
          ...formData,
          [key]: e.value,
          administrator_beneficial_user_telephone_no:
            data.attributes.telephone_no,
          administrator_beneficial_user_tin: data.attributes.tin,
          administrator_beneficial_user_region_code:
            data.attributes.region_name,
          administrator_beneficial_user_province_code:
            data.attributes.province_name,
          administrator_beneficial_user_municipality_code:
            data.attributes.municipality_name,
          administrator_beneficial_user_barangay_code:
            data.attributes.barangay_name,
          administrator_beneficial_user_address_line:
            data.attributes.address_line,
        });
      });
    }
    setFormData({
      ...formData,
      [key]: e.value,
    });
  };

  useEffect(() => {
    getDistrictList({
      province_id: 65,
    });
  }, []);

  const paginateButton = () => {
    return (
      <div className="py-1">
        {tab !== 9 && (
          <div className="col-12 d-flex justify-content-center mt-3">
            {tab !== 0 && (
              <button
                type="button"
                onClick={() => setTab(+tab - 1 < 0 ? 0 : +tab - 1)}
                className="btn btn-light button-cancel-2 mr-1"
                style={{ backgroundColor: '#323943', color: '#fff' }}
              >
                Back
              </button>
            )}
            {tab === 0 && (
              <button
                type="button"
                onClick={closeModal}
                className="btn btn-light button-cancel-2 mr-1"
                style={{ backgroundColor: '#323943', color: '#fff' }}
              >
                Cancel
              </button>
            )}
            <button
              type="submit"
              className="btn btn-light button-proceed ml-1 cms-bg-color-primary text-light"
              disabled={
                (tab === 0 && !tab0Validator.response.is_passed) ||
                (tab === 2 && !tab2Validator.response.is_passed) ||
                (tab === 2 && formData.td_owner === '') ||
                (tab === 3 && !tab3Validator.response.is_passed) ||
                (tab === 4 && !tab4Validator.response.is_passed) ||
                (tab === 5 && formData.structural_materials.length === 0) ||
                (tab === 6 && formData.structural_materials.length === 0) ||
                (tab === 7 && formData.structural_materials.length === 0)
              }
            >
              Proceed
            </button>
          </div>
        )}
        {tab === 9 && (
          <div className="col-12 d-flex justify-content-center mt-3">
            <button
              type="button"
              onClick={() => setTab(+tab - 1 < 0 ? 0 : +tab - 1)}
              className="btn btn-link button-cancel-2 mr-1"
              style={{ backgroundColor: '#323943', color: '#fff' }}
            >
              Previous
            </button>
            <button
              type="submit"
              disabled={isLoading || tab === 9 && !tab9Validator.response.is_passed}
              className="btn btn-light button-proceed ml-1 cms-bg-color-primary"
              style={{ color: '#fff' }}
            >
              {isLoading && <i className="fa fa-spin fa-spinner" />}{" "}
              Proceed
            </button>
          </div>
        )}
      </div>
    );
  };

  const ownerOptions = ownerList.map((x) => ({
    label: _.get(x, 'attributes.full_name'),
    value: x.id,
    id: x.id,
  }));

  const appointedPersonsOptions = appointedPersonsList.map((x) => ({
    label: _.get(x, 'attributes.full_name'),
    value: x.id,
    id: x.id,
  }));

  const buildingKindsOptions = buildingKindsList.map((x) => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  const structuralTypesOptions = structuralTypesList.map((x) => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  const handleOnChangeDate = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e.target.value,
    });
  };

  const onChangePhoto = (key) => (data) => {
    setFormData({
      ...formData,
      [key]: data.cdnUrl,
    });
  };

  const handleFloorAreaChange = (data) => {
    setFormData({
      ...formData,
      floor_storey_areas: data.floor_storey_areas,
      total_floor_area: data.total_floor_area,
      no_of_storeys: +data.no_of_storeys,
    });
  };

  const searchTdn = (e) => {
    e.preventDefault();
    if (formData.for_improvement === 0) {
      findTdn(
        {
          tdn: formData.rptax_land_application_id,
          rptax_transaction_code_id: transactionCode,
        },
        (landData) => {
          if (!_.isEmpty(landData)) {
            Alert.success('Application Found.');
            getBarangayList({
              rptax_district_id: _.get(
                landData,
                'data.attributes.property_district_id'
              ),
            });
            setFormData({
              ...formData,
              land_application_id: _.get(landData, 'data.id'),
              td_owner: _.get(landData, 'included.[1].attributes.name'),
              td_oct: _.get(landData, 'data.attributes.oct_tct_cloa_no'),
              td_oct_date: _.get(
                landData,
                'data.attributes.oct_tct_cloa_dated'
              ),
              td_survey_no: _.get(landData, 'data.attributes.survey_no'),
              td_lot_no: _.get(landData, 'data.attributes.lot_no'),
              td_block: _.get(landData, 'data.attributes.blk'),
              td_area: _.get(landData, 'data.attributes.total_appraisal_area'),
              property_barangay_id: _.get(
                landData,
                'data.attributes.property_barangay_id'
              ),
              property_district_id: _.get(
                landData,
                'data.attributes.property_district_id'
              ),
              property_street: _.get(
                landData,
                'data.attributes.property_street'
              ),
            });
          } else {
            Alert.error('No Application Found.');
          }
        }
      );
    } else {
      searchPin(
        formData.rptax_building_application_id,
        transactionCode,
        (landData) => {
          if (!_.isEmpty(landData)) {
            Alert.success('Application Found.');
            showData(_.get(landData, 'data.id'), (info) => {
              getBarangayList({
                rptax_district_id: _.get(
                  info,
                  'data.attributes.property_district_id'
                ),
              });
              setFormData({
                ...formData,
                building_application_id: _.get(landData, 'data.id'),
                td_owner: _.get(
                  info,
                  'data.included.landApplication.attributes.rptax_owner_name'
                ),
                td_oct: _.get(
                  info,
                  'data.included.landApplication.attributes.oct_tct_cloa_no'
                ),
                td_oct_date: _.get(
                  landData,
                  'data.included.landApplication.attributes.oct_tct_cloa_dated'
                ),
                td_survey_no: _.get(
                  info,
                  'data.included.landApplication.attributes.survey_no'
                ),
                td_lot_no: _.get(
                  info,
                  'data.included.landApplication.attributes.lot_no'
                ),
                td_block: _.get(
                  info,
                  'data.included.landApplication.attributes.blk'
                ),
                td_area: _.get(
                  info,
                  'data.included.landApplication.attributes.total_appraisal_area'
                ),
                property_barangay_id: _.get(
                  info,
                  'data.included.landApplication.attributes.property_barangay_id'
                ),
                property_district_id: _.get(
                  info,
                  'data.included.landApplication.attributes.property_district_id'
                ),
                property_street: _.get(
                  info,
                  'data.included.landApplication.attributes.property_street'
                ),
              });
            });
          } else {
            Alert.error('No Application Found.');
          }
        }
      );
    }
  };

  const onChangeCheckbox = (e) => {
    const for_improvement = +_.get(formData, 'for_improvement', 0) ? 0 : 1;

    let newValue = e.target.value;
    if (e.target.name === 'for_improvement') {
      newValue = for_improvement;
    }

    setFormData({
      ...formData,
      [e.target.name]: newValue,
      land_application_id: '',
      building_application_id: '',
      rptax_land_application_id: '',
      rptax_building_application_id: '',
      td_owner: '',
      td_oct: '',
      td_oct_date: '',
      td_lot_no: '',
      td_block: '',
      td_area: '',
      property_barangay_id: '',
      property_district_id: '',
      property_street: '',
    });
  };

  const handleChange = (key) => (data) => {
    setFormData({
      ...formData,
      [key]: data,
    });
  };

  const yearOptions = years.map((year) => ({
    label: year,
    value: year,
  }));

  const handleSelected = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e.value,
    });
  };

  useEffect(() => {
    if (modalType === 'NEW') {
      setFormData({
        ...c.FORM_DATA,
        property_region_id:
          _.get(
            CMS_COMPONENTS,
            'SMART_CITY_SET_SPECIFIC_REGION_FOR_ADDRESS_BILLING'
          ) || '',
        property_province_id:
          _.get(
            CMS_COMPONENTS,
            'SMART_CITY_SET_SPECIFIC_PROVINCE_FOR_ADDRESS_BILLING'
          ) || '',
      });
    }
  }, []);

  useEffect(() => {
    if (modalType === 'EDIT') {
      getBarangayList({
        rptax_district_id: _.get(updateList, 'attributes.property_district_id'),
      });
      getStructuralTypesList(
        _.get(updateList, 'attributes.rptax_building_kind_id'),
        {
          status: 1,
        }
      );
      getBarangayList({
        rptax_district_id: _.get(updateList, 'attributes.property_district_id'),
      });
      setFormData({
        ...c.FORM_DATA,
        ...formData,
        id: updateList.id,
        date_issued: `${moment(
          _.get(updateList, 'attributes.date_issued')
        ).format('MM-DD-YYYY')}`,
        certificate_completion_issued_on: `${moment(
          _.get(updateList, 'attributes.certificate_completion_issued_on')
        ).format('MM-DD-YYYY')}`,
        certificate_occupancy_issued_on: `${moment(
          _.get(updateList, 'attributes.certificate_occupancy_issued_on')
        ).format('MM-DD-YYYY')}`,
        date_constructed_completed: `${moment(
          _.get(updateList, 'attributes.date_constructed_completed')
        ).format('MM-DD-YYYY')}`,
        date_occupied: `${moment(
          _.get(updateList, 'attributes.date_occupied')
        ).format('MM-DD-YYYY')}`,

        appraised_assessed_at: `${moment(
          _.get(updateList, 'attributes.appraised_assessed_at')
        ).format('MM-DD-YYYY HH:mm:ss')}`,
        recommending_at: `${moment(
          _.get(updateList, 'attributes.recommending_at')
        ).format('MM-DD-YYYY HH:mm:ss')}`,
        approved_at: `${moment(
          _.get(updateList, 'attributes.approved_at')
        ).format('MM-DD-YYYY HH:mm:ss')}`,
        registered: `${moment(
          _.get(updateList, 'attributes.registered')
        ).format('MM-DD-YYYY HH:mm:ss')}`,

        condominium_certificate_title:
          _.get(updateList, 'attributes.condominium_certificate_title') || '',
        condominium_certificate_title_date: updateList.attributes
          .condominium_certificate_title_date
          ? `${moment(
            updateList.attributes.condominium_certificate_title_date
          ).format('MM-DD-YYYY')}`
          : '',

        property_province_id: _.get(
          updateList,
          'attributes.property_province_id'
        ),
        property_district_id: _.get(
          updateList,
          'attributes.property_district_id'
        ),
        property_barangay_id: _.get(
          updateList,
          'attributes.property_barangay_id'
        ),
        property_street: _.get(updateList, 'attributes.property_street'),
        rptax_transaction_code_id: _.get(
          updateList,
          'attributes.rptax_transaction_code_id'
        ),
        tdn: _.get(updateList, 'attributes.tdn'),
        arp_no: _.get(updateList, 'attributes.arp_no'),
        pin: _.get(updateList, 'attributes.pin'),
        property_boundaries_north: _.get(
          updateList,
          'attributes.property_boundaries_north'
        ),
        property_boundaries_south: _.get(
          updateList,
          'attributes.property_boundaries_south'
        ),
        property_boundaries_east: _.get(
          updateList,
          'attributes.property_boundaries_east'
        ),
        property_boundaries_west: _.get(
          updateList,
          'attributes.property_boundaries_west'
        ),
        property_boundaries_land_sketch_photo_url: _.get(
          updateList,
          'attributes.property_boundaries_land_sketch_photo_url'
        ),
        rptax_building_kind_id: _.get(
          updateList,
          'attributes.rptax_building_kind_id'
        ),
        rptax_building_structural_type_id:
          _.get(updateList, 'attributes.rptax_building_structural_type_id') ||
          '',
        building_permit_no: _.get(updateList, 'attributes.building_permit_no'),
        building_age: _.get(updateList, 'attributes.building_age'),
        floor_plan_photo_url: _.get(
          updateList,
          'attributes.floor_plan_photo_url'
        ),
        effectivity_of_assessment_reassessment_qtr: _.get(
          updateList,
          'attributes.effectivity_of_assessment_reassessment_qtr'
        ),
        effectivity_of_assessment_reassessment_yr: _.get(
          updateList,
          'attributes.effectivity_of_assessment_reassessment_yr'
        ),
        appraised_assessed_by_id: _.get(
          updateList,
          'attributes.appraised_assessed_by_id'
        ),
        recommending_by_id: _.get(updateList, 'attributes.recommending_by_id'),
        approved_by_id: _.get(updateList, 'attributes.approved_by_id'),
        no_of_storeys: _.get(updateList, 'attributes.no_of_storeys'),
        floor_storey_areas: formatFloorArea(
          _.get(updateList, 'included.floorStoreyArea') || []
        ),
        total_floor_area: +_.get(updateList, 'attributes.total_floor_area'),
        structural_materials: formatStructuralMaterials(
          _.get(updateList, 'included.structuralMaterial') || []
        ),
        additional_items:
          formatAddionalItems(_.get(updateList, 'included.addedItems')) || [],
        rptax_owner_id: _.get(updateList, 'attributes.rptax_owner_id'),
        administrator_beneficial_user_id: _.get(
          updateList,
          'attributes.administrator_beneficial_user_id'
        ),
        owner_telephone_no: _.get(
          updateList,
          'included.buildingOwner.attributes.telephone_no'
        ),
        owner_tin: _.get(updateList, 'included.buildingOwner.attributes.tin'),
        owner_region_code: _.get(
          updateList,
          'included.buildingOwner.attributes.region_name'
        ),
        owner_province_code: _.get(
          updateList,
          'included.buildingOwner.attributes.province_name'
        ),
        owner_municipality_code: _.get(
          updateList,
          'included.buildingOwner.attributes.municipality_name'
        ),
        owner_barangay_code: _.get(
          updateList,
          'included.buildingOwner.attributes.barangay_name'
        ),
        address_line: _.get(
          updateList,
          'included.buildingOwner.attributes.address_line'
        ),
        administrator_beneficial_user_telephone_no: _.get(
          updateList,
          'included.administratorBeneficialUser.attributes.telephone_no'
        ),
        administrator_beneficial_user_tin: _.get(
          updateList,
          'included.administratorBeneficialUser.attributes.tin'
        ),
        administrator_beneficial_user_region_code: _.get(
          updateList,
          'included.administratorBeneficialUser.attributes.region_name'
        ),
        administrator_beneficial_user_province_code: _.get(
          updateList,
          'included.administratorBeneficialUser.attributes.province_name'
        ),
        administrator_beneficial_user_municipality_code: _.get(
          updateList,
          'included.administratorBeneficialUser.attributes.municipality_name'
        ),
        administrator_beneficial_user_barangay_code: _.get(
          updateList,
          'included.administratorBeneficialUser.attributes.barangay_name'
        ),
        administrator_beneficial_user_address_line: _.get(
          updateList,
          'included.administratorBeneficialUser.attributes.address_line'
        ),
        for_improvement: _.get(updateList, 'attributes.for_improvement'),
        rptax_land_application_id: _.get(
          updateList,
          'included.landApplication.attributes.tdn'
        ),
        land_application_id: _.get(
          updateList,
          'attributes.rptax_land_application_id'
        ),
        building_application_id: _.get(
          updateList,
          'attributes.rptax_building_application_id'
        ),
        rptax_building_application_id: _.get(
          updateList,
          'included.buildingApplication.attributes.pin'
        ),
        td_owner: _.get(
          updateList,
          'included.landApplication.attributes.rptax_owner_name'
        ),
        td_oct: _.get(
          updateList,
          'included.landApplication.attributes.oct_tct_cloa_no'
        ),
        td_oct_date: _.get(
          updateList,
          'included.landApplication.attributes.oct_tct_cloa_dated'
        ),
        td_survey_no: _.get(
          updateList,
          'included.landApplication.attributes.survey_no'
        ),
        td_lot_no: _.get(
          updateList,
          'included.landApplication.attributes.lot_no'
        ),
        td_block: _.get(updateList, 'included.landApplication.attributes.blk'),
        td_area: _.get(
          updateList,
          'included.landApplication.attributes.total_appraisal_area'
        ),
        memoranda: htmlToDraft(_.get(updateList, 'attributes.memoranda')),
      });
    }
  }, []);

  useEffect(() => {
    if (_.get(formData, 'rptax_building_structural_type_id')) {
      setFormData({
        ...formData,
        buv: structuralTypesList?.find(
          (item) =>
            +item.id === +_.get(formData, 'rptax_building_structural_type_id')
        )?.attributes?.unit_construction_cost,
      });
    }
  }, [
    _.get(formData, 'rptax_building_structural_type_id'),
    structuralTypesList,
  ]);

  useEffect(() => {
    if (formData.for_improvement === 0) {
      commonValidationTab2 = {
        ...commonValidationTab2,
        rptax_land_application_id: 'required|rptax_tdn',
      };
    } else if (formData.for_improvement === 1) {
      commonValidationTab2 = {
        ...commonValidationTab2,
        rptax_building_application_id: 'required|rptax_pin',
      };
    }
    tab2Validator.onSetObjectRules(commonValidationTab2);
  }, [formData]);

  const districtOptions = districtList.map((x) => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  const barangayOptions = barangayList.map((x) => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  const onChangeTaxPayerAddress = (e) => {
    setFormData({
      ...formData,
      region_code: e.target.value.region_code,
      province_code: e.target.value.province_code,
    });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="m-1 p-1">
          {tab === 0 && (
            <>
              <div className="row">
                <div className="col-12 mb-2">
                  <div className="header-modal">Owner Details</div>
                </div>
                <div className="col-6 form-group">
                  <label className="form-label">
                    Owner: &nbsp;{' '}
                    {tab0Validator.renderMessage('rptax_owner_id')}
                  </label>
                  <div>
                    <Select
                      options={ownerOptions}
                      placeholder="-Select-"
                      value={
                        ownerOptions.filter(
                          (item) =>
                            +_.get(formData, 'rptax_owner_id') ===
                            +_.get(item, 'id')
                        ) || ''
                      }
                      onChange={handleOnChangeSelect('rptax_owner_id')}
                    />
                  </div>
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label">
                    Telephone No.
                  </label>
                  <InputMask
                    readOnly
                    className="form-control"
                    mask="99-9999-9999"
                    alwaysShowMask
                    type="text"
                    name="owner_telephone_no"
                    onChange={onChange}
                    value={_.get(formData, 'owner_telephone_no')}
                  />
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Tax Identification Number
                  </label>
                  <InputMask
                    className="form-control"
                    mask="999-999-999-999"
                    readOnly
                    type="text"
                    name="owner_tin"
                    onChange={onChange}
                    value={_.get(formData, 'owner_tin') || ''}
                  />
                </div>
                <div className="col-12 mt-2 mb-2">
                  <div className="header-modal">Address</div>
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Region
                  </label>
                  <input
                    className="form-control text-uppercase"
                    type="text"
                    readOnly
                    name="owner_region_code"
                    onChange={onChange}
                    value={_.get(formData, 'owner_region_code') || ''}
                  />
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Province
                  </label>
                  <input
                    className="form-control text-uppercase"
                    type="text"
                    readOnly
                    name="owner_province_code"
                    onChange={onChange}
                    value={_.get(formData, 'owner_province_code') || ''}
                  />
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Municipality
                  </label>
                  <input
                    className="form-control text-uppercase"
                    type="text"
                    readOnly
                    name="owner_municipality_code"
                    onChange={onChange}
                    value={_.get(formData, 'owner_municipality_code') || ''}
                  />
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Barangay
                  </label>
                  <input
                    className="form-control text-uppercase"
                    type="text"
                    readOnly
                    name="owner_barangay_code"
                    onChange={onChange}
                    value={_.get(formData, 'owner_barangay_code') || ''}
                  />
                </div>
                <div className="col-12 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Unit No. / House No. / Street Name
                  </label>
                  <input
                    className="form-control text-uppercase"
                    type="text"
                    readOnly
                    name="address_line"
                    onChange={onChange}
                    value={_.get(formData, 'address_line') || ''}
                  />
                </div>
              </div>
              <hr className="below-hr" />
              {paginateButton()}
            </>
          )}
          {tab === 1 && (
            <>
              <div className="row mt-4">
                <div className="col-12 mb-2">
                  <div className="header-modal">
                    Administrator/Beneficial User Details
                  </div>
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="first_name" className="form-label">
                    Administrator/Beneficial User
                  </label>
                  <Select
                    options={ownerOptions}
                    placeholder="-Select-"
                    value={
                      ownerOptions.filter(
                        (item) =>
                          +_.get(
                            formData,
                            'administrator_beneficial_user_id'
                          ) === +_.get(item, 'id')
                      ) || ''
                    }
                    onChange={handleOnChangeSelect(
                      'administrator_beneficial_user_id'
                    )}
                  />
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label">
                    Telephone No.
                  </label>
                  <InputMask
                    className="form-control"
                    mask="99-9999-9999"
                    alwaysShowMask
                    type="text"
                    readOnly
                    name="administrator_beneficial_user_telephone_no"
                    onChange={onChange}
                    value={_.get(
                      formData,
                      'administrator_beneficial_user_telephone_no'
                    )}
                  />
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Tax Identification Number
                  </label>
                  <InputMask
                    className="form-control"
                    mask="999-999-999-999"
                    readOnly
                    type="text"
                    name="administrator_beneficial_user_tin"
                    onChange={onChange}
                    value={
                      _.get(formData, 'administrator_beneficial_user_tin') || ''
                    }
                  />
                </div>
                <div className="col-12 mt-2 mb-2">
                  <div className="header-modal">Address</div>
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Region
                  </label>
                  <input
                    className="form-control text-uppercase"
                    type="text"
                    readOnly
                    name="administrator_beneficial_user_region_code"
                    onChange={onChange}
                    value={
                      _.get(
                        formData,
                        'administrator_beneficial_user_region_code'
                      ) || ''
                    }
                  />
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Province
                  </label>
                  <input
                    className="form-control text-uppercase"
                    type="text"
                    readOnly
                    name="administrator_beneficial_user_province_code"
                    onChange={onChange}
                    value={
                      _.get(
                        formData,
                        'administrator_beneficial_user_province_code'
                      ) || ''
                    }
                  />
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Municipality
                  </label>
                  <input
                    className="form-control text-uppercase"
                    type="text"
                    readOnly
                    name="administrator_beneficial_user_municipality_code"
                    onChange={onChange}
                    value={
                      _.get(
                        formData,
                        'administrator_beneficial_user_municipality_code'
                      ) || ''
                    }
                  />
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Barangay
                  </label>
                  <input
                    className="form-control text-uppercase"
                    type="text"
                    readOnly
                    name="administrator_beneficial_user_barangay_code"
                    onChange={onChange}
                    value={
                      _.get(
                        formData,
                        'administrator_beneficial_user_barangay_code'
                      ) || ''
                    }
                  />
                </div>
                <div className="col-12 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Unit No. / House No. / Street Name
                  </label>
                  <input
                    className="form-control text-uppercase"
                    type="text"
                    readOnly
                    name="administrator_beneficial_user_address_line"
                    onChange={onChange}
                    value={
                      _.get(
                        formData,
                        'administrator_beneficial_user_address_line'
                      ) || ''
                    }
                  />
                </div>
              </div>
              <hr className="below-hr" />
              {paginateButton()}
            </>
          )}
          {tab === 2 && (
            <>
              <div className="row">
                <div className="col-6 mb-2">
                  <div className="header-modal">Land Reference</div>
                </div>
                <div className="col-6 form-group ml-auto">
                  <label htmlFor="last_name" className="form-label">
                    For Improvement &nbsp;
                  </label>
                  <input
                    name="for_improvement"
                    type="checkbox"
                    checked={_.get(formData, 'for_improvement')}
                    onChange={onChangeCheckbox}
                  />
                </div>
                {formData.for_improvement === 0 ? (
                  <div className="col-6 form-group">
                    <label htmlFor="last_name" className="form-label mb-0">
                      TDN/ARP No.
                      {tab2Validator.renderMessage('rptax_land_application_id')}
                    </label>
                    <div
                      className="input-group mb-3 col-12 mt-2"
                      style={{ marginLeft: -15 }}
                    >
                      <InputMask
                        className="form-control"
                        mask="aa-99999-99999"
                        alwaysShowMask
                        type="text"
                        name="rptax_land_application_id"
                        onChange={onChange}
                        value={_.get(formData, 'rptax_land_application_id')}
                      />
                      <div className="input-group-append">
                        <button
                          disabled={
                            _.get(formData, 'rptax_land_application_id') ===
                            '__-_____-_____' ||
                            _.get(formData, 'rptax_land_application_id') === ''
                          }
                          type="button"
                          onClick={searchTdn}
                          className="btn btn-link button-search cms-bg-color-secondary cms-outline-secondary"
                        >
                          <span className="icon">
                            <i className="fa fa-lg fa-search" />
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="col-6 form-group">
                    <label htmlFor="last_name" className="form-label mb-0">
                      PIN
                      {tab2Validator.renderMessage(
                        'rptax_building_application_id'
                      )}
                    </label>
                    <div
                      className="input-group mb-3 col-12 mt-2"
                      style={{ marginLeft: -15 }}
                    >
                      <InputMask
                        className="form-control"
                        mask="999-99-999-999-999-a9999"
                        alwaysShowMask
                        type="text"
                        name="rptax_building_application_id"
                        onChange={onChange}
                        value={_.get(formData, 'rptax_building_application_id')}
                      />
                      <div className="input-group-append">
                        <button
                          disabled={
                            _.get(formData, 'rptax_building_application_id') ===
                            '___-__-___-___-___-_____' ||
                            _.get(formData, 'rptax_building_application_id') ===
                            ''
                          }
                          type="button"
                          onClick={searchTdn}
                          className="btn btn-link button-search cms-bg-color-secondary cms-outline-secondary"
                        >
                          <span className="icon">
                            <i className="fa fa-lg fa-search" />
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                )}
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Owner
                  </label>
                  <input
                    className="form-control text-uppercase mt-2"
                    type="text"
                    readOnly
                    name="td_owner"
                    onChange={onChange}
                    value={_.get(formData, 'td_owner') || ''}
                  />
                </div>
                <div className="col-3 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    OCT/TCT/CLOA No.
                  </label>
                  <input
                    className="form-control text-uppercase"
                    type="text"
                    readOnly
                    name="td_oct"
                    onChange={onChange}
                    value={_.get(formData, 'td_oct') || ''}
                  />
                </div>
                <div className="col-3 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    OCT Date
                  </label>
                  <input
                    className="form-control text-uppercase"
                    type="text"
                    readOnly
                    name="td_oct_date"
                    onChange={onChange}
                    value={_.get(formData, 'td_oct_date') || ''}
                  />
                </div>
                <div className="col-2 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Survey No.
                  </label>
                  <input
                    className="form-control text-uppercase"
                    type="text"
                    readOnly
                    name="td_survey_no"
                    onChange={onChange}
                    value={_.get(formData, 'td_survey_no') || ''}
                  />
                </div>
                <div className="col-3 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Lot No.
                  </label>
                  <input
                    className="form-control text-uppercase"
                    type="text"
                    readOnly
                    name="td_lot_no"
                    onChange={onChange}
                    value={_.get(formData, 'td_lot_no') || ''}
                  />
                </div>
                <div className="col-2 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Block
                  </label>
                  <input
                    className="form-control text-uppercase"
                    type="text"
                    readOnly
                    name="td_block"
                    onChange={onChange}
                    value={_.get(formData, 'td_block') || ''}
                  />
                </div>
                <div className="col-2 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Area
                  </label>
                  <input
                    className="form-control text-uppercase"
                    type="text"
                    readOnly
                    name="td_area"
                    onChange={onChange}
                    value={_.get(formData, 'td_area') || ''}
                  />
                </div>
                <div className="col-12 mb-2">
                  <div className="header-modal">Building Location</div>
                </div>
                <div className="col-12 form-group">
                  <AddressRemove
                    required
                    value={{
                      region_code: _.get(formData, 'region_code') || '',
                      province_code: _.get(formData, 'province_code') || '',
                    }}
                    onChange={onChangeTaxPayerAddress}
                    region_name="region_code"
                    province_name="province_code"
                    name="tax_payer_address"
                    withStreet={false}
                    removeLabel
                    isDisabled
                  />
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    District
                  </label>
                  <Select
                    options={districtOptions}
                    isDisabled
                    styles={customStyle}
                    placeholder="Select District"
                    value={
                      districtOptions.filter(
                        (item) =>
                          +_.get(formData, 'property_district_id') ===
                          +_.get(item, 'id')
                      ) || ''
                    }
                    onChange={handleOnChangeSelect('property_district_id')}
                  />
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Barangay
                  </label>
                  <Select
                    isDisabled
                    options={barangayOptions}
                    styles={customStyle}
                    placeholder="Select Barangay"
                    value={
                      barangayOptions.filter(
                        (item) =>
                          +_.get(formData, 'property_barangay_id') ===
                          +_.get(item, 'id')
                      ) || ''
                    }
                    onChange={handleOnChangeSelect('property_barangay_id')}
                  />
                </div>
                <div className="col-12 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Unit No. / House No. / Street Name
                  </label>
                  <input
                    readOnly
                    className="form-control text-uppercase"
                    type="text"
                    name="property_street"
                    onChange={onChange}
                    value={_.get(formData, 'property_street') || ''}
                  />
                </div>
              </div>
              <hr className="below-hr" />
              {paginateButton()}
            </>
          )}
          {tab === 3 && (
            <>
              <div className="row mt-4">
                <div className="col-12 mb-2">
                  <div className="header-modal">General Description</div>
                </div>
                <div className="col-6 form-group">
                  <label className="form-label">
                    Kind of Building &nbsp;{' '}
                    {tab3Validator.renderMessage('rptax_building_kind_id')}
                  </label>
                  <div>
                    <Select
                      options={buildingKindsOptions}
                      placeholder="Select Building Kind"
                      value={
                        buildingKindsOptions.filter(
                          (item) =>
                            +_.get(formData, 'rptax_building_kind_id') ===
                            +_.get(item, 'id')
                        ) || ''
                      }
                      onChange={handleOnChangeSelect('rptax_building_kind_id')}
                    />
                  </div>
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label">
                    Building Age &nbsp;{' '}
                  </label>
                  <input
                    className="form-control"
                    type="number"
                    name="building_age"
                    onChange={onChange}
                    value={_.get(formData, 'building_age') || ''}
                  />
                </div>
                <div className="col-6 form-group">
                  <label className="form-label">
                    Structural Type &nbsp;{' '}
                    {tab3Validator.renderMessage(
                      'rptax_building_structural_type_id'
                    )}
                  </label>
                  <div>
                    <Select
                      options={structuralTypesOptions}
                      placeholder="Select Structural Type"
                      value={
                        structuralTypesOptions.find((item) => {
                          return (
                            `${_.get(
                              formData,
                              'rptax_building_structural_type_id'
                            )}` === _.get(item, 'value')
                          );
                        }) || ''
                      }
                      onChange={handleOnChangeSelect(
                        'rptax_building_structural_type_id'
                      )}
                      isDisabled={_.isEmpty(formData.rptax_building_kind_id)}
                      isLoading={structuralTypesIsLoading}
                    />
                  </div>
                </div>
                {(+formData.rptax_building_kind_id === 1 ||
                  +formData.rptax_building_kind_id === 2) && (
                    <>
                      <div className="col-6 form-group">
                        <label htmlFor="last_name" className="form-label mb-0">
                          Condominium Certificate Title{' '}
                          {tab3Validator.renderMessage(
                            'condominium_certificate_title'
                          )}
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          name="condominium_certificate_title"
                          onChange={onChange}
                          value={
                            _.get(formData, 'condominium_certificate_title') || ''
                          }
                        />
                      </div>
                      <div className="form-group col-6">
                        <label htmlFor="last_name" className="form-label mb-0">
                          Condominium Certificate Title Date{' '}
                          {tab3Validator.renderMessage(
                            'condominium_certificate_title_date'
                          )}
                        </label>
                        <DateInputPicker
                          className="full-input"
                          onChange={handleOnChangeDate(
                            'condominium_certificate_title_date'
                          )}
                          value={
                            _.get(
                              formData,
                              'condominium_certificate_title_date'
                            ) || ''
                          }
                          maxDate={new Date()}
                        />
                      </div>
                    </>
                  )}
                <div className="col-6 form-group" />
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Building Permit No. &nbsp;{' '}
                    {tab3Validator.renderMessage('building_permit_no')}
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    name="building_permit_no"
                    onChange={onChange}
                    value={_.get(formData, 'building_permit_no') || ''}
                  />
                </div>
                <div className="form-group col-6">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Date Issued &nbsp;{' '}
                    {tab3Validator.renderMessage('date_issued')}
                  </label>
                  <DateInputPicker
                    className="full-input"
                    onChange={handleOnChangeDate('date_issued')}
                    value={_.get(formData, 'date_issued') || ''}
                    maxDate={new Date()}
                  />
                </div>
                <div className="form-group col-6">
                  <label className="form-label">
                    Certificate Completion Issued On &nbsp;{' '}
                    {tab3Validator.renderMessage(
                      'certificate_completion_issued_on'
                    )}
                  </label>
                  <DateInputPicker
                    className="full-input"
                    onChange={handleOnChangeDate(
                      'certificate_completion_issued_on'
                    )}
                    value={
                      _.get(formData, 'certificate_completion_issued_on') || ''
                    }
                    maxDate={new Date()}
                  />
                </div>
                <div className="form-group col-6">
                  <label className="form-label">
                    Certificate Occupancy Issued On &nbsp;{' '}
                    {tab3Validator.renderMessage(
                      'certificate_occupancy_issued_on'
                    )}
                  </label>
                  <DateInputPicker
                    className="full-input"
                    onChange={handleOnChangeDate(
                      'certificate_occupancy_issued_on'
                    )}
                    value={
                      _.get(formData, 'certificate_occupancy_issued_on') || ''
                    }
                    maxDate={new Date()}
                  />
                </div>
                <div className="form-group col-6">
                  <label className="form-label">
                    Date Constructed Completed &nbsp;{' '}
                    {tab3Validator.renderMessage('date_constructed_completed')}
                  </label>
                  <DateInputPicker
                    className="full-input"
                    onChange={handleOnChangeDate('date_constructed_completed')}
                    value={_.get(formData, 'date_constructed_completed') || ''}
                    maxDate={new Date()}
                  />
                </div>
                <div className="form-group col-6">
                  <label className="form-label">
                    Date Occupied &nbsp;{' '}
                    {tab3Validator.renderMessage('date_occupied')}
                  </label>
                  <DateInputPicker
                    className="full-input"
                    onChange={handleOnChangeDate('date_occupied')}
                    value={_.get(formData, 'date_occupied') || ''}
                    maxDate={new Date()}
                  />
                </div>
              </div>
              <hr className="below-hr" />
              {paginateButton()}
            </>
          )}
          {tab === 4 && (
            <>
              <div className="row mt-4">
                <div className="col-12 mb-2">
                  <div className="header-modal">Floor Area</div>
                </div>
                <div className="col-12 form-group">
                  <FloorArea
                    onChange={handleFloorAreaChange}
                    floor_storey_areas={formData.floor_storey_areas || []}
                    total_floor_area={formData.total_floor_area || 0}
                    modalType={modalType}
                    no_of_storeys={formData.no_of_storeys || 0}
                  />
                </div>
                <div className="col-12 form-group">
                  <div className="col-12 mt-2 mb-2">
                    <div className="header-modal">
                      Upload Floor Plan &nbsp;{' '}
                      {tab4Validator.renderMessage('floor_plan_photo_url')}
                    </div>
                  </div>
                  <div className="row d-flex">
                    <div className="col-3">
                      <div
                        className="generic-listing bg-primary p-3 arrow rounded"
                        style={{
                          // overflowY: 'scroll',
                          display: 'block',
                        }}
                      >
                        <label className="form-label text-white">
                          Building Plan or Sketch of Floor Plan
                        </label>
                      </div>
                    </div>
                    <div className="col-12 col-md-8">
                      <div className="form-wrapper arrow-card p-4">
                        {!_.get(formData, 'floor_plan_photo_url') ? (
                          <DragAndDrop
                            onChange={onChangePhoto('floor_plan_photo_url')}
                            maxSize={2}
                            caption="JPEG. PNG. Maximum size 2MB."
                            label="Upload your Requirements here"
                            fileType="image/jpeg, image/jpg, image/png"
                          />
                        ) : (
                          <div className="bg-dark text-center py-2 pb-5 rounded">
                            <div className="d-flex justify-content-end col-1">
                              {createUploader(
                                {
                                  key: 'floor_plan_photo_url',
                                  label: 'Sketch',
                                },
                                { placeholder: '  ' }
                              )}
                            </div>
                            <img
                              src={
                                !_.isObject(
                                  _.get(formData, 'floor_plan_photo_url') || ''
                                )
                                  ? _.get(formData, 'floor_plan_photo_url') ||
                                  ImagePlaceholder
                                  : _.get(
                                    formData,
                                    'floor_plan_photo_url.cdnUrl'
                                  ) || ImagePlaceholder
                              }
                              className="img-fluid shadow-lg"
                              role="presentation"
                              width="100%"
                              alt=""
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr className="below-hr" />
              {paginateButton()}
            </>
          )}
          {tab === 5 && (
            <>
              <div className="row mt-4">
                <StructuralMaterialsList
                  value={formData.structural_materials || []}
                  setShowPaginateButton={setShowPaginateButton}
                  onChange={handleChange('structural_materials')}
                  type="Roof"
                  modalType={modalType}
                />
              </div>
              {showPaginateButton === false && (
                <>
                  <hr className="below-hr" />
                  {paginateButton()}
                </>
              )}
            </>
          )}
          {tab === 6 && (
            <>
              <div className="row mt-4">
                <StructuralMaterialsList
                  value={formData.structural_materials || []}
                  setShowPaginateButton={setShowPaginateButton}
                  onChange={handleChange('structural_materials')}
                  type="Flooring"
                  floorArea={formData.floor_storey_areas || 0}
                  modalType={modalType}
                />
              </div>
              {showPaginateButton === false && (
                <>
                  <hr className="below-hr" />
                  {paginateButton()}
                </>
              )}
            </>
          )}
          {tab === 7 && (
            <>
              <div className="row mt-4">
                <StructuralMaterialsList
                  value={formData.structural_materials || []}
                  setShowPaginateButton={setShowPaginateButton}
                  onChange={handleChange('structural_materials')}
                  type="Walls & Partitions"
                  floorArea={formData.floor_storey_areas || 0}
                  modalType={modalType}
                />
              </div>
              {showPaginateButton === false && (
                <>
                  <hr className="below-hr" />
                  {paginateButton()}
                </>
              )}
            </>
          )}
          {tab === 8 && (
            <>
              <div className="row mt-4">
                <AdditionalItemsList
                  value={formData.additional_items || []}
                  setShowPaginateButton={setShowPaginateButton}
                  onChange={handleChange('additional_items')}
                  floorArea={formData.floor_storey_areas || 0}
                  buvAmount={formData.buv || 0}
                  ordinanceRevisionId={+ordinanceRevisionId}
                />
              </div>
              {showPaginateButton === false && (
                <>
                  <hr className="below-hr" />
                  {paginateButton()}
                </>
              )}
            </>
          )}
          {tab === 9 && (
            <>
              <div className="row">
                <div className="col-12 py-0 mb-2">
                  <h3 className="m-0 text-color font-weight-bold">
                    General Description - Effectivity of Assessment /
                    Reassessment
                  </h3>
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Effectivity of Assessment Year &nbsp;{' '}
                    {tab9Validator.renderMessage(
                      'effectivity_of_assessment_reassessment_yr'
                    )}
                  </label>
                  <Select
                    options={yearOptions}
                    styles={customStyle}
                    placeholder="Select Year"
                    value={yearOptions.find(
                      (item) =>
                        item.value ===
                        _.get(
                          formData,
                          'effectivity_of_assessment_reassessment_yr'
                        )
                    )}
                    onChange={handleSelected(
                      'effectivity_of_assessment_reassessment_yr'
                    )}
                  />
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Effectivity of Assessment Quarter: &nbsp;{' '}
                    {tab9Validator.renderMessage(
                      'effectivity_of_assessment_reassessment_qtr'
                    )}
                  </label>
                  <Select
                    styles={customStyle}
                    placeholder="Select Quarter"
                    value={
                      quarterList.filter(
                        (item) =>
                          `${item.value}` ===
                          _.get(
                            formData,
                            'effectivity_of_assessment_reassessment_qtr'
                          )
                      )[0]
                    }
                    options={quarterList}
                    onChange={handleSelected(
                      'effectivity_of_assessment_reassessment_qtr'
                    )}
                  />
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Appraised/Assessed By &nbsp;{' '}
                    {tab9Validator.renderMessage('appraised_assessed_by_id')}
                  </label>
                  <Select
                    options={appointedPersonsOptions}
                    placeholder="-Select-"
                    value={
                      appointedPersonsOptions.filter(
                        (item) =>
                          +_.get(formData, 'appraised_assessed_by_id') ===
                          +_.get(item, 'id')
                      ) || ''
                    }
                    onChange={handleOnChangeSelect('appraised_assessed_by_id')}
                  />
                </div>
                <div className="form-group col-6">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Appraised/Assessed At: &nbsp;{' '}
                    {tab9Validator.renderMessage('appraised_assessed_at')}
                  </label>
                  <DateInputPicker
                    withTime
                    className="full-input"
                    onChange={handleOnChangeDate('appraised_assessed_at')}
                    value={_.get(formData, 'appraised_assessed_at') || ''}
                    maxDate={new Date()}
                  />
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Recommended By &nbsp;{' '}
                    {tab9Validator.renderMessage('recommending_by_id')}
                  </label>
                  <Select
                    options={appointedPersonsOptions}
                    placeholder="-Select-"
                    value={
                      appointedPersonsOptions.filter(
                        (item) =>
                          +_.get(formData, 'recommending_by_id') ===
                          +_.get(item, 'id')
                      ) || ''
                    }
                    onChange={handleOnChangeSelect('recommending_by_id')}
                  />
                </div>
                <div className="form-group col-6">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Recommended At: &nbsp;{' '}
                    {tab9Validator.renderMessage('recommending_at')}
                  </label>
                  <DateInputPicker
                    withTime
                    className="full-input"
                    onChange={handleOnChangeDate('recommending_at')}
                    value={_.get(formData, 'recommending_at') || ''}
                    maxDate={new Date()}
                  />
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Approved By &nbsp;{' '}
                    {tab9Validator.renderMessage('approved_by_id')}
                  </label>
                  <Select
                    styles={{
                      menu: base => ({
                        ...base,
                        zIndex: 900,
                      }),
                    }}
                    options={appointedPersonsOptions}
                    placeholder="-Select-"
                    value={
                      appointedPersonsOptions.filter(
                        (item) =>
                          +_.get(formData, 'approved_by_id') ===
                          +_.get(item, 'id')
                      ) || ''
                    }
                    onChange={handleOnChangeSelect('approved_by_id')}
                  />
                </div>
                <div className="form-group col-6">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Approved At: &nbsp;{' '}
                    {tab9Validator.renderMessage('approved_at')}
                  </label>
                  <DateInputPicker
                    withTime
                    className="full-input"
                    onChange={handleOnChangeDate('approved_at')}
                    value={_.get(formData, 'approved_at') || ''}
                    maxDate={new Date()}
                  />
                </div>
                <div className="form-group col-6">
                  <label className="form-label">
                    Registered: &nbsp;{' '}
                    {tab9Validator.renderMessage('registered')}
                  </label>
                  <DateInputPicker
                    withTime
                    className="full-input"
                    onChange={handleOnChangeDate('registered')}
                    value={_.get(formData, 'registered') || ''}
                    maxDate={new Date()}
                  />
                </div>
                <div className="col-12 form-group">
                  {createRichTextEditor(
                    { key: 'memoranda', label: 'Memoranda:' },
                    { minLength: 3, required: true }
                  )}
                </div>
              </div>
              <hr className="below-hr" style={{ marginTop: 55 }} />
              {paginateButton()}
            </>
          )}
        </div>
      </form>
    </Modal.Body>
  );
}

NewDeclarationModal.defaultProps = {
  modalType: '',
  transactionCode: 0,
  applicationId: '',
};

NewDeclarationModal.propTypes = {
  getOwnerList: PropTypes.instanceOf(Function).isRequired,
  ownerList: PropTypes.instanceOf(Array).isRequired,
  getBuildingKindsList: PropTypes.instanceOf(Function).isRequired,
  buildingKindsList: PropTypes.instanceOf(Array).isRequired,
  getStructuralTypesList: PropTypes.instanceOf(Function).isRequired,
  structuralTypesList: PropTypes.instanceOf(Array).isRequired,
  createUploader: PropTypes.instanceOf(Function).isRequired,
  createApplication: PropTypes.instanceOf(Function).isRequired,
  getApplicationsList: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  structuralTypesIsLoading: PropTypes.bool.isRequired,
  getSingleBuildingOwner: PropTypes.instanceOf(Function).isRequired,
  findTdn: PropTypes.instanceOf(Function).isRequired,
  transactionCode: PropTypes.number,
  createRichTextEditor: PropTypes.instanceOf(Function).isRequired,
  showStructuralType: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  modalType: PropTypes.string,
  updateList: PropTypes.instanceOf(Object).isRequired,
  getBarangayList: PropTypes.instanceOf(Function).isRequired,
  barangayList: PropTypes.instanceOf(Array).isRequired,
  getDistrictList: PropTypes.instanceOf(Function).isRequired,
  districtList: PropTypes.instanceOf(Array).isRequired,
  convertToRaw: PropTypes.instanceOf(Function).isRequired,
  draftToHtml: PropTypes.instanceOf(Function).isRequired,
  updateApplication: PropTypes.instanceOf(Function).isRequired,
  htmlToDraft: PropTypes.instanceOf(Function).isRequired,
  getAppointedPersons: PropTypes.instanceOf(Function).isRequired,
  appointedPersonsList: PropTypes.instanceOf(Array).isRequired,
  searchPin: PropTypes.instanceOf(Function).isRequired,
  showData: PropTypes.instanceOf(Function).isRequired,
  applicationId: PropTypes.string,
  ordinanceRevisionId: PropTypes.number.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  isLoading: _.get(api, "loading", []).indexOf(c.CREATE_APPLICATION) > -1,
  updateList: _.get(api, `${c.SHOW_DATA}.item`) || {},
  ownerList: _.get(api, `${c.GET_OWNER_LIST}.list`) || [],
  barangayList: _.get(api, `${c.GET_BARANGAYS}.list`) || [],
  districtList: _.get(api, `${c.GET_DISTRICTS_LIST}.list`) || [],
  buildingKindsList: _.get(api, `${c.GET_BUILDING_KINDS_LIST}.list`) || [],
  structuralTypesIsLoading:
    _.get(api, 'loading', []).indexOf(c.GET_STRUCTURAL_TYPES_LIST) > -1,
  structuralTypesList: _.get(api, `${c.GET_STRUCTURAL_TYPES_LIST}.list`) || [],
  appointedPersonsList: _.get(api, `${c.GET_APPOINTED_PERSONS}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(NewDeclarationModal);
